import type { ReactNode } from "react";
import { cn } from "../../utils/cn";

type DsPageContainerProps = {
  children: ReactNode;
  className?: string;
};

function DsPageContainer ({ children, className }: DsPageContainerProps) {
  return (
    <div className={cn("min-h-dvh w-full bg-dark-light-mode-background font-inter", className)}>
      {children}
    </div>
  );
};

export { DsPageContainer };
